module.exports = __webpack_public_path__ + "img/slider-image-03-isanon.3a11aab7.png";